import React, { FC } from 'react'

const TwoCollumAdd:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/two-collum-add.png" alt=''/>
        </div>
    </div>
  )
}

export default TwoCollumAdd